export const settingsTableModalName = 'settings-table';
